module.exports = __webpack_public_path__ + "img/grin-squint-tears.a80480f6.svg";